import styled from 'styled-components'

export const ContainerCards = styled.div`
  padding: 32px 2px 2px 32px;
  display: flex;
  align-items: center;
  gap: 32px;
  width: 100%;
  flex-wrap: wrap;

  @media (max-width: 900px) {
    flex-direction: column;
  }
`
